import { Skeleton } from "@mui/material";
import { DDD, E2Data } from "../../lib/ddd/ddd";
import classes from "./DashboardComponents.module.scss";
import { useQuery } from "@tanstack/react-query";
import { useContext, useEffect, useState } from "react";
import { Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { OrgIdContext } from "../../store/orgId_context";
import ButtonLink from "../UI/ButtonLink";
import ModalWindow from "../UI/ModalWindow";
import GenericModal from "../UI/GenericModal";
import FungAddFunds from "./FungAddFunds";
import PaymentIcon from '@mui/icons-material/Payment';
import { Hourglass } from "react-loader-spinner";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useTranslation } from 'react-i18next';

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const e2Data = new E2Data("EU_AOrg");
e2Data.format = "Full";
const ddd = new DDD(apiRequestAddress);

const CurrentFinancialState = () => {
    const { t } = useTranslation();
    const [data, setData] = useState();
    const {aboutOrgId, sessionInfo, setSessionInfoHandler } = useContext(OrgIdContext);
    const [showPaymentModal, setShowPaymentModal] = useState();
    const [paymentLoading, setPaymentLoading] = useState();
    const [waitingForCheckoutCompletion, setWaitingForPaymentCompletion] = useState();
    const [waitingError, setWaitingsError] = useState();

    const {isPending : isLoading, data : queryData} = useQuery({
        queryKey: ['Data.GetEntityData', e2Data.GetParamsObject()],
        queryFn: () => e2Data.GetData(),
    });

    useEffect(() => {
        if(isLoading || !queryData)return;
        setData(queryData.result?.data[0]);
    }, [queryData,isLoading]);

    const dateExists =  data?.NextPaymentDate;
    const date = new Date(data?.NextPaymentDate);
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    const formattedDateString = date
        .toLocaleDateString("en-GB", options)
        .replace(/\//g, ".");
    
    const paymentCompleted = (amount, checkoutId) => {
      setWaitingForPaymentCompletion(true);
      sendCheckCheckoutRequest(checkoutId);
      /*setPaymentLoading(true);
      let current =  sessionInfo?.Extended?.AccountBalance ? sessionInfo?.Extended?.AccountBalance : 0;
      current = current + parseFloat(amount);
      const e2Data_EU_AOrg = new E2Data("EU_AOrg");
      e2Data_EU_AOrg.filter = `Id="${aboutOrgId}"`;
      e2Data_EU_AOrg.values = {AccountBalance : current}
      e2Data_EU_AOrg.Modify().then(() => {
        ddd.InvalidateSessionExtensions().then(() => {
          ddd.GetSessionAuthDescribe({includeExtendedInfo: true}).then(res => {
              if(res?.result)
                setSessionInfoHandler(res.result);
              setPaymentLoading(false);
          });
        });
      });*/
      
    }

    const sendCheckCheckoutRequest = (checkoutId) => {
      ddd.Rpc_ExecuteExtension("EUeInvoices.FungAddFundsStatus", {"CheckoutId" : checkoutId}).then(res =>{
        if(res?.result?.Status === "Error"){
          setWaitingForPaymentCompletion(false);
          return setWaitingsError(res?.result?.Reason);
        }

        if(res?.result?.Result === "CreditedNow" || res?.result?.Result === "Credited"){
          setWaitingForPaymentCompletion(false);
          return refreshCurrentFunds();
        }

        if(res?.result?.Result === "Waiting"){
          setTimeout(() => {
            sendCheckCheckoutRequest(checkoutId);
          }, 2000);
        }
      });
    }

    const refreshCurrentFunds = () =>{
      setPaymentLoading(true);
      ddd.InvalidateSessionExtensions().then(() => {
        ddd.GetSessionAuthDescribe({includeExtendedInfo: true}).then(res => {
            if(res?.result)
              setSessionInfoHandler(res.result);
            setPaymentLoading(false);
        });
      });
    }

    return (<>
    <div className={classes.container}>
      <Row>
        <Col className="col-12 col-md-6">
          <h2 className={`mb-3 ${classes.subtitle}`}>{t("Current funds")}</h2>
          <p className={classes.package}>
            {paymentLoading && <Skeleton/>}
            {!paymentLoading && (<>
              <span className={`ms-2 ${classes["funds"]} ${sessionInfo?.Extended?.AccountBalance<0 ? classes["funds-red"] : classes["funds-green"]}`}>
                {waitingError && <OverlayTrigger placement="top" overlay={<Tooltip>{waitingError}</Tooltip>}>
                  <ErrorOutlineIcon style={{color:"red"}}/>
                </OverlayTrigger>}
                {waitingForCheckoutCompletion && <Hourglass height="1rem" width="1rem" colors={['#005683', '#df511d']}/>}
                {(!sessionInfo?.Extended?.AccountBalance || sessionInfo?.Extended?.AccountBalance==="") ? "0.00" : sessionInfo?.Extended?.AccountBalance}€
              </span>
              
            </>)}
          </p>
        </Col>
        <Col className="col-12 col-md-6 d-flex align-items-center justify-content-center justify-content-md-end mb-3 mb-md-0">
          <ButtonLink  /*onClick={() => setShowPaymentModal(true)}*/ className="px-4 py-1"  style={{opacity:"0.6"}} >
            {t("Add funds")}
          </ButtonLink>
          <GenericModal show={showPaymentModal} onHide={() => setShowPaymentModal(false)} title="Add funds" icon={<PaymentIcon/>}>
            <FungAddFunds onPaymentCompleted={paymentCompleted} onClose={() => setShowPaymentModal(false)}/>
          </GenericModal>
        </Col>
      </Row>
      {/* <Row>
        <Col className="col-12 col-md-6">
          <p>
            Last billing:{" "}
            <span className={classes.key}>
              {!data && <Skeleton/>}
              {data?.DateOfLastBillProcess || "/"}
            </span>
          </p>
        </Col>
        <Col className="col-12 col-md-6">
          {data?.IsTrial ? (
            <p>
              Next payment:{" "}
              <span className={classes.key}>
                {data  && <>
                  {dateExists? formattedDateString : "/"}
                </>}
                {!data && <Skeleton/>}
              </span>
            </p>
          ) : (
            <p>
              Valid until:{" "}
              <span className={classes.key}>
                {data  && <>
                  {dateExists? formattedDateString : "/"}
                </>}
                {!data && <Skeleton/>}
              </span>
            </p>
          )}
        </Col>
      </Row> */}
    </div>
    </>);
}

export default CurrentFinancialState;